/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { DefaultShipping, DefaultBilling } from '@/store/modules/checkout/defaultValues'

export function checkout () {
  return {
    namespaced: true,
    state: {
      shippingAddress: { ...DefaultShipping },
      billingAddress: { ...DefaultBilling },
      paymentMethods: [],
      paymentMethod: {
        current: '',
        paymentMethodAdditional: {}
      },
      stepPosition: {
        index: 0,
        value: ''
      },
      extensionAttributes: {},
      tmpOrder: {},
      placeOrderAction: null,
      postPlaceOrderAction: null,
      shippingMethods: [],
      shippingMethod: null,
      countries: [],
      cart: {},
      terms: [],
      userInfo: {
        createUser: false,
        gender: '',
        dob: '',
        password: '',
        profile: false
      }
    },
    getters,
    actions,
    mutations
  }
}
